var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { matchRoutes } from 'react-router-config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions';
import * as _ from 'lodash';
import FuseLayouts from './layouts';
var styles = function (theme) { return ({
    root: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        '& table.simple tbody tr td': {
            borderColor: theme.palette.divider,
        },
        '& table.simple thead tr th': {
            borderColor: theme.palette.divider,
        },
        '& a:not([role=button])': {
            // color: theme.palette.secondary.main,
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        '& [class^="border-"]': {
            borderColor: theme.palette.divider,
        },
        '& [class*="border-"]': {
            borderColor: theme.palette.divider,
        },
    },
}); };
// @ts-ignore
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.routeSettingsCheck = function () {
            var matched = matchRoutes(_this.props.routes, _this.props.location.pathname)[0];
            if (matched && matched.route.settings) {
                var routeSettings = _.merge({}, _this.props.defaultSettings, matched.route.settings);
                if (!_.isEqual(_this.props.settings, routeSettings)) {
                    _this.props.setSettings(_.merge({}, routeSettings));
                }
            }
            else {
                if (!_.isEqual(_this.props.settings, _this.props.defaultSettings)) {
                    _this.props.resetSettings();
                }
            }
        };
        _this.routeSettingsCheck();
        return _this;
    }
    Layout.prototype.componentDidUpdate = function (prevProps) {
        if (!_.isEqual(this.props.location.pathname, prevProps.location.pathname)) {
            this.routeSettingsCheck();
        }
    };
    Layout.prototype.componentDidCatch = function (error, errorInfo) {
        if (this.props.isDevStage)
            return;
        Sentry.withScope(function (scope) {
            Object.keys(errorInfo).forEach(function (key) {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    };
    Layout.prototype.render = function () {
        var _a = this.props, settings = _a.settings, classes = _a.classes;
        // console.warn('FuseLayout:: rendered');
        var Layout = FuseLayouts[settings.layout.style].component;
        return React.createElement(Layout, __assign({ className: classes.root }, this.props));
    };
    Layout = __decorate([
        withStyles(styles, { withTheme: true })
    ], Layout);
    return Layout;
}(React.PureComponent));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSettings: Actions.setSettings,
        setDefaultSettings: Actions.setDefaultSettings,
        resetSettings: Actions.resetSettings,
        navbarOpenFolded: Actions.navbarOpenFolded,
        navbarCloseFolded: Actions.navbarCloseFolded,
        navbarOpenMobile: Actions.navbarOpenMobile,
        navbarCloseMobile: Actions.navbarCloseMobile,
    }, dispatch);
}
function mapStateToProps(_a) {
    var fuse = _a.fuse;
    return {
        defaultSettings: fuse.settings.defaults,
        settings: fuse.settings.current,
        navbar: fuse.navbar,
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));



//////////////////
// WEBPACK FOOTER
// ./src/theme/layout/index.tsx
// module id = 1497
// module chunks = 81